import { render, staticRenderFns } from "./AreYouSureModalComponent.vue?vue&type=template&id=712cf1a1"
import script from "./AreYouSureModalComponent.vue?vue&type=script&lang=js"
export * from "./AreYouSureModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports